var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"omapi-no-connection-buttons"},[_c('core-wizard-button',[_vm._v("Create a Free Account")]),_c('span',[_vm._v("or")]),_c('core-connect-button',{attrs:{"size":"medium"}},[_vm._v("Connect an Existing Account")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }